import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed, ref } from "vue";
import { routes } from "@/router/routes";
import { useRouter } from "vue-router";
import { useLoginUserStore } from "@/store/userStore";
import checkAccess from "@/access/checkAccess";


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const loginUserStore = useLoginUserStore();

const router = useRouter();
//当前栏选中菜单项
const selectedKeys = ref(["/"]);
//路由跳转时，自动更新选中的菜单项
router.afterEach((to,from,failure) =>{
	selectedKeys.value = [to.path];
});
//点击菜单跳转到对应的页面
const doMenuClick = (key:string) =>{
	router.push({
		path: key,
	});
};
//展示在菜单栏的路由数组
const visibleRoutes = computed( () =>{
	return routes.filter((item) => {
		if(item.meta?.hideInMenu){
			return false;
		}
		//根据权限验证显示菜单
		if (!checkAccess(loginUserStore.loginUser, item.meta?.access as string)) {
		  return false;
		}
		return true;
});
});


return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    class: "GlobalHeader",
    align: "center",
    wrap: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { flex: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "horizontal",
            "selected-keys": selectedKeys.value,
            onMenuItemClick: doMenuClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, {
                key: "0",
                style: { padding: 0, marginRight: '38px' },
                disabled: ""
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("div", { class: "titleBar" }, [
                    _createElementVNode("img", {
                      class: "logo",
                      src: _imports_0
                    }),
                    _createElementVNode("div", { class: "title" }, "智能问答")
                  ], -1)
                ])),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoutes.value, (item) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-keys"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { flex: "100px" }, {
        default: _withCtx(() => [
          (_unref(loginUserStore).loginUser.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(loginUserStore).loginUser.userName ?? "匿名用户"), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  href: "/user/login"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("登录")
                  ])),
                  _: 1
                })
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})